export const MailingState = Object.freeze({
	DRAFT: 'draft',
	FINAL: 'final',
	OFFERED: 'offered',
	CANCELLED: 'canceled',
});
